module.exports = __webpack_public_path__ + "static/media/whatsapp-logo.dbde6d9e.svg";